import * as React from 'react'
import get from 'lodash-es/get'

import ImagePlaceholder from '../../../imagePlaceholder'
import CardDetails from '../cardDetails/cardDetails'
import CardPreview from '../cardPreview/cardPreview'
import AudioPlayerContainer from '../../../audioPlayer/audioPlayerContainer'

import { ICard } from '../elementsPromoItemsBlock'

import * as styles from './audioCard.module.css'

const AudioCard = ({
  title,
  author,
  itemURL,
  categoryName,
  imageRatios,
  previews,
  marketID,
  onClick,
  showCTA
}: ICard) => {
  const src = get(previews, 'icon_with_audio_preview.mp3_url')
  const length = get(previews, 'icon_with_audio_preview.length')
  return (
    <div>
      <CardPreview categoryName={categoryName}>
        <ImagePlaceholder
          ratio={imageRatios.previewRatio}
          className={styles.placeholder}
        >
          <div className={styles.playerArea}>
            <AudioPlayerContainer
              src={src}
              length={length}
              id={marketID}
              viewType="grid"
            />
          </div>
        </ImagePlaceholder>
      </CardPreview>
      <a
        className={styles.link}
        href={itemURL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`View ${title}`}
        onClick={() => onClick && onClick()}
      >
        <CardDetails
          title={title}
          author={author}
          categoryName={categoryName}
          showCTA={showCTA}
        />
      </a>
    </div>
  )
}

export default AudioCard
